/**
 * @author czy
 * @description 返利中心--返利规则配置
 */

import * as func from '@/func'

const enumToList = func.enumToList()

//  活动类型;1书单活动、2供货商活动、3全品类活动、4单品类活动、5禁止参与品种
export enum EnumActivityType {
  书单活动 = 1,
  供应商活动 = 2,
  全品类活动 = 3,
  单品类活动 = 4,
  禁止参与品种 = 5,
}

// 活动级别;1普通活动、2优先活动、3年度活动
export enum EnumActivityLevel {
  普通活动 = 1,
  优先活动 = 2,
  年度活动 = 3,
}

// 返利规则状态;1草稿，2待审核，3审核失败，4已生效，5已失效
export enum EnumRebateRuleStatus {
  草稿 = 1,
  待审核 = 2,
  审核失败 = 3,
  已生效 = 4,
  已失效 = 5,
}
